 
import React from "react";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { StandadCard } from "../../../../../../components/Cards";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { LoadState, MODULE_IDS } from "../../../../../../constants/enums";
import { useDispatchWrapper,
  useBreadcrumb,
} from "../../../../../../hooks";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  Box,
  Checkbox,
  Grid,
  Stack,
} from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../components/formsComponents";

import moment from "moment";
import { CustomDatePicker } from "../../../../../../components/formsComponents/CustomDatePicker";
import {
  addBusinesPolicyToolFloaterAsync,
  addLeadBusinessToolFloaterAsync,
  clearBusinessToolFloater,
  fetchBusinessPolicyToolFloaterAsync,
  fetchLeadToolFloaterAsync,
} from "../../../../../../redux/businessPolicy/businessPolicyToolFloater/businessPolicyToolFloaterActions";
import {
  ILocationResponsePayload,
  LocationAutoComplete,
} from "../../../../../../components/LocationAutoComplete/LocationAutoComplete";
import { CurrencyTextField } from "../../../../../../components/CurrencyTextField/CurrencyTextField";
import { isAlphaNumericCapital } from "../../../../../../helpers/isAlphaNumericCapital";
import { RoleBasedCustomButton } from "../../../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { InterestedPartyCodeSearchSelect } from "../../../../../../components/AutoCompleteSearches/InterestedPartyCodeSearchSelect";
import { IBusinessPolicyInterested } from "../../../../../../redux/businessPolicy/businessPolicyInterested/businessPolicyInterested.types";
import { COMMON_STATUS } from "../../../../../../constants/constants";
import { IBusinessPolicyToolFloater } from "../../../../../../redux/businessPolicy/businessPolicyToolFloater/businesPolicyToolFloater.types";
import { FieldSet } from "../../../../../../components/FieldSet/FieldSet";
import { PageContainer } from "../../../../../../components/container/PageContainer";
interface ToolFloaterProps {
  customerId?: number;
  customerPolicyId?: number;
  /** Lead-scoped identifier. When present, the form saves/fetches by lead_id. */
  leadId?: string;
  toolFloaterNumber?: number;
  readOnly?: boolean;
  fromRightPanel?: boolean;
  staticStatusValue?: string;
  created_from?: string;
  onSaveSuccess: (tooFloater: IBusinessPolicyToolFloater) => void;
  initialData?: IBusinessPolicyToolFloater;
  disableApiCalls?: boolean;
  disableSaveApi?: boolean;
}
export const ToolFloater: React.FC<ToolFloaterProps> = (props) => {
  const {
    customerId,
    customerPolicyId,
    leadId,
    toolFloaterNumber,
    onSaveSuccess,
    readOnly = false,
    fromRightPanel = false,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls = false,
    disableSaveApi = false,
  } = props;

  useBreadcrumb({
    title: "",
    items: [
    {
      to: "/policies/",
      title: "all-policies ",
    },
    {
      to: "/policies/Business%20Policy",
      title: "business",
    },
    {
      to: "/customer-overview/" + customerId,
      title: "customer",
    },
    {
      to:
        "/business-policy/" +
        customerId +
        "/schedule-tab/" +
        customerPolicyId +
        `?tab=1`,
      title: "tool-floaters",
    },
    {
      title: toolFloaterNumber ? "edit-tool-floater" : "add-tool-floater",
    },
  ],
  });


  const { toolFloaterLoading, toolfloater, error } = useSelector(
    (storeState: IStoreState) => storeState.business.toolFloater
  );
  const [saveLoading, setSaveLoading] = React.useState(false);
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();

  const { values, handleChange, handleSubmit, setFieldValue, setValues } =
    useFormik({
      initialValues: initialData ? initialData : toolfloater,
      validate: (values) => {},
      onSubmit: (values) => {
        if (disableSaveApi) {
          onSaveSuccess(values);
        } else {
          let statusValue = values.status;
          if (staticStatusValue) {
            statusValue = staticStatusValue;
          }
          // Lead-binder scope: save by lead_id (no customer_policy_id required).
          if (leadId) {
            setSaveLoading(true);
            dispatch(
              addLeadBusinessToolFloaterAsync(
                {
                  ...values,
                  status: statusValue,
                  created_from: created_from || "Tool_Floater",
                },
                { leadId },
                (isSuccess, toolFloater) => {
                  if (isSuccess && toolFloater) {
                    window.scrollTo(0, 0);
                    onSaveSuccess(toolFloater);
                  }
                  setSaveLoading(false);
                }
              )
            );
            return;
          }
          if (customerPolicyId && customerId) {
            setSaveLoading(true);
            dispatch(
              addBusinesPolicyToolFloaterAsync(
                {
                  ...values,
                  customer_id: customerId,
                  customer_policy_id: customerPolicyId,
                  status: statusValue,
                  created_from: created_from || "Tool_Floater",
                },
                (isSuccess, toolFloater) => {
                  if (isSuccess && toolFloater) {
                    window.scrollTo(0, 0);
                    onSaveSuccess(toolFloater);
                  }
                  setSaveLoading(false);
                }
              )
            );
          }
        }
      },
    });

  const handleAddress = (data: ILocationResponsePayload) => {
    setValues({
      ...values,
      address: data.address,
      city: data.city,
      country: data.country,
      province_or_state: data.state,
      postal_code: data.postalCode,
    });
  };
  const handleSerialNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;
    const sanitizedValue = isAlphaNumericCapital(value);
    setFieldValue(name, sanitizedValue);
  };

  React.useEffect(() => {
    if (disableApiCalls || !toolFloaterNumber) {
      return;
    }
    if (leadId) {
      dispatch(fetchLeadToolFloaterAsync({ leadId }, toolFloaterNumber));
    } else if (customerPolicyId) {
      dispatch(
        fetchBusinessPolicyToolFloaterAsync(customerPolicyId, toolFloaterNumber)
      );
    }
  }, [customerPolicyId, leadId, toolFloaterNumber]);

  React.useEffect(() => {
    if (initialData && disableApiCalls) {
      return;
    }
    setValues({
      ...toolfloater,
      incremental_number: toolFloaterNumber || null,
      effective_date: moment().format("YYYY-MM-DD"),
    });
  }, [toolfloater]);

  React.useEffect(() => {
    return () => {
      dispatch(clearBusinessToolFloater());
    };
  }, []);

  const handleIntrestedPartyCode = (data: IBusinessPolicyInterested) => {
    if (data) {
      setValues({
        ...values,
        interest: data.interest || "",
        interested_party_code: data.interested_party_code || "",
        interested_party: data.interested_party || "",
        address: data.address || "",
        unit_or_suite: data.unit_or_suite || "",
        city: data.city || "",
        country: data.country || "",
        province_or_state: data.province_or_state || "",
        postal_code: data.postal_code || "",
      });
    }
  };

  const intrestedParities = useSelector(
    (storeState: IStoreState) =>
      storeState.borkerage.intrestedParties.intrestedParties.list
  );

  const intrestedParitiesDropdown = React.useMemo(() => {
    return intrestedParities.map((item) => {
      return {
        label: item.interested_party_code,
        value: item.interested_party_code || "",
      };
    });
  }, [intrestedParities]);

  return (
 <PageContainer
      title={toolFloaterNumber ? "edit-tool-floater" : "add-tool-floater"}
      description="this is inner page"
    >    <PageLoader
      loading={toolFloaterLoading === LoadState.InProgress}
      error={error ? { message: error } : undefined}
    >
      <StandadCard
        sx={{ mt: 2 }}
        renderWithoutCard={fromRightPanel}
        heading={!fromRightPanel ? "Tool Floater" : ""}
      >
        <form onSubmit={handleSubmit}>
          <FieldSet disabled={readOnly}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={1}>
                <CustomFormLabel>#</CustomFormLabel>
                <CustomTextField
                  name="incremental_number"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.incremental_number}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <CustomFormLabel>Effective Date</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  value={values.effective_date || ""}
                  onChange={(newValue) => {
                    setFieldValue("effective_date", newValue);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <CustomFormLabel>Year</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  views={["year"]}
                  inputFormat="YYYY"
                  value={values.year || ""}
                  onChange={(newValue, x, momentObject) => {
                    const newDate = moment(momentObject).format("YYYY");
                    setFieldValue("year", momentObject ? newDate : null);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3.8}>
                <CustomFormLabel>Serial Number</CustomFormLabel>
                <CustomTextField
                  name="serial_number"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.serial_number}
                  onChange={handleSerialNumberChange}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <CustomFormLabel>Limit ($)</CustomFormLabel>
                <CurrencyTextField
                  fullWidth
                  value={values.limit_amount}
                  onChange={(value) => {
                    setFieldValue("limit_amount", value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <CustomFormLabel>Purchase Date</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  value={values.purchase_date || ""}
                  onChange={(newValue) => {
                    setFieldValue("purchase_date", newValue);
                  }}
                />
              </Grid>

              <Grid item xs={12} lg={3}>
                <InterestedPartyCodeSearchSelect
                  label="Interested Party Code"
                  value={values.interested_party_code}
                  onSelect={(value) => handleIntrestedPartyCode(value)}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <CustomFormLabel>Intersted Party</CustomFormLabel>
                <CustomTextField
                  name="interested_party"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.interested_party}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <CustomFormLabel>Interest</CustomFormLabel>
                <CustomTextField
                  name="interest"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.interest}
                  // error={errors.name ? true : false}
                  // helperText={errors.name}
                  // disabled={isUpdateLead}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomFormLabel>Address</CustomFormLabel>
                <LocationAutoComplete
                  id="address"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.address}
                  onLocationChange={handleAddress}
                />
              </Grid>
              <Grid item xs={12} lg={1.5}>
                <CustomFormLabel>Unit/Suite</CustomFormLabel>
                <CustomTextField
                  id="unit_or_suite"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.unit_or_suite}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={2}>
                <CustomFormLabel>City</CustomFormLabel>
                <CustomTextField
                  id="city"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.city}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={2}>
                <CustomFormLabel>State/Province</CustomFormLabel>
                <CustomTextField
                  id="province_or_state"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.province_or_state}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={1.5}>
                <CustomFormLabel>Postal Code</CustomFormLabel>
                <CustomTextField
                  id="postal_code"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.postal_code}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={2}>
                <CustomFormLabel>Country</CustomFormLabel>
                <CustomTextField
                  id="country"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.country}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomFormLabel>Description</CustomFormLabel>
                <CustomTextField
                  name="description"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  multiline
                  rows={3}
                  value={values.description}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomFormLabel>Note</CustomFormLabel>
                <CustomTextField
                  name="note"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  multiline
                  rows={3}
                  value={values.note}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={4} sx={{ mt: 3 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Checkbox
                    name="tool_floater_submission_checkbox"
                    size="medium"
                    color="primary"
                    checked={values.tool_floater_submission_checkbox === "Y"}
                    onChange={(e, checked) => {
                      setFieldValue(
                        "tool_floater_submission_checkbox",
                        checked ? "Y" : "N"
                      );
                    }}
                  />
                  <CustomFormLabel sx={{ fontSize: "16px" }}>
                    Submission
                  </CustomFormLabel>
                </Stack>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} lg={4}>
                <CustomFormLabel>Status</CustomFormLabel>
                <ControlledCustomSelect
                  fullWidth
                  value={values.status}
                  name="status"
                  onChange={handleChange}
                  placeholder="Select one"
                  displayEmpty
                  options={COMMON_STATUS}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 4 }}>
              <RoleBasedCustomButton
                sx={{ width: "15%" }}
                disabled={saveLoading}
                variant="contained"
                moduleKey={MODULE_IDS.BUSINESS_POLICY}
                type="submit"
              >
                Save
              </RoleBasedCustomButton>
            </Box>
          </FieldSet>
        </form>
      </StandadCard>
    </PageLoader>
    </PageContainer>
  );
};
